import React from 'react'

class TableErrorBoundary extends React.Component {
    state = {
        error: false
    }

    static getDerivedStateFromError(error) {
        return { error: true }
    }

    componentDidCatch(error, errorInfo) {
        console.log('TableErrorBoundary', error, errorInfo)
    }

    render() {
        if (this.state.error) {
            return null
        }
        return this.props.children
    }
}

export default TableErrorBoundary
